<script>
    import Card from "../../../Components/Card/Card.svelte";
    import Button from "../../../Components/Button/Button.svelte";
    import SelectGroup from "../../../Components/SelectGroup/SelectGroup.svelte";
    import { User, request, russianMonths, getNewsData } from "../../../store";
    import Editor from "../../../Components/Editor/Editor.svelte";
    // import Carousel from "../../../Components/Carousel/Carousel.svelte";

    let user;
    let category = [
        {
            name: "Новость",
        },
        {
            name: "Турнир",
        }
    ];

    let myDate;
    $: date = new Date(myDate);
    $: formattedDate = `${date?.getDate()} ${
        russianMonths[date?.getMonth()]
    } ${date?.getFullYear()}`;

    let form = {
        id: "",
        newsCover: "",
        title: "",
        category: -1,
        description: "",
        images: "",
        videos: "",
        date: "",
        isNew: true
    };
    let news = "";

    $: images = form.images.split("\n") ? form.images.split("\n") : [];

    User.subscribe((value) => {
        user = value;
    });

    function addNews(isNew) {
        form.date = myDate;
        form.isNew = isNew;
        request("/news/add", "POST", JSON.stringify(form)).then((response) => {
            if (response) {
                window.location.pathname = "/news/" + response;
            }
        });
    }
</script>

<div id="content">
    <h1 class="unselectable" style="margin-top: 0;">Добавить новость</h1>

    <div class="form">
        <div class="main-data">
            <input
                type="text"
                bind:value={form.title}
                placeholder="Заголовок"
            />
            <input
                type="text"
                bind:value={form.newsCover}
                placeholder="Ссылка на обложку"
            />
            <input
                type="date"
                bind:value={myDate}
                placeholder="Дата публикации"
            />
            <SelectGroup
                class="category"
                header="Выберите категорию"
                items={category}
                bind:chosenItem={form.category}
            />
            <div class="button">
                <Button on:click={() => {addNews(true)}} size=large >
                    Добавить
                </Button>
            </div>
        </div>
    </div>
    <Editor bind:content={form.description} />
    <div class="preview">
        <h3>Предпросмотр</h3>
        <div class="news-preview">
            <div class="news-card">
                <Card src={form.newsCover}>
                    <a class="pointer" style="margin: 5px; font-size: large;">
                        {form.title}
                    </a>
                    <div class="small" style="margin: 5px; opacity: 0.8;">
                        {!formattedDate.includes("undefined")
                            ? formattedDate
                            : ""}
                    </div>
                </Card>
            </div>
        </div>
    </div>
</div>

<style lang="less" global>
    @import "add.less";
</style>
